import ReactDOM from 'react-dom/client';

import { initSentry } from 'utils/config/sentry';

import App from 'src/App.tsx';
import 'src/index.css';

initSentry();

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
